<div>
  @if (show) {
    <div
      id="snackbar"
      style="background-color: #a59800; z-index: 100000; position: absolute"
      class="show"
      >
      {{ message }}
    </div>
  }

  <div class="details_info">
    <p>Please choose a bank to continue with payment.</p>
  </div>
  <div>
    <select
      class="form-control"
      id="exampleFormControlSelect1"
      (change)="generateUSSD($event.target.value)"
      [disabled]="isDisabled"
      [(ngModel)]="bankCode"
      >
      <option value="" disabled>Select Bank</option>
      @for (bank of banks; track bank) {
        <option [value]="bank.Code">
          {{ bank.name | uppercase }}
        </option>
      }
    </select>
  </div>
  <div class="details_holder" style="text-align: center">
    @if (isProcessing) {
    } @else {
      @if (!ussdPaymentRes.providerResponse) {
        <p>
          Your USSD payment code will show here
        </p>
      }
      @if (ussdPaymentRes.providerExtraInfo && !isProcessing) {
        <p>Dial the below code to complete payment</p>
        <h2>{{ ussdPaymentRes.providerExtraInfo }}</h2>
        <p
          (click)="checkPaymentStatus()"
          id="txn-check"
          [style.color]="whiteLabelInfo ? whiteLabelInfo.brandColor : '#ed1c25'"
          >
          Check Transaction Status
        </p>
      }
    }
  </div>
  <div
    class="footer"
    style="margin-top: 70px; text-align: center; font-size: 8px"
    >
    <app-footer style="margin-top: 8rem" [whiteLabelInfo]="whiteLabelInfo" />
  </div>
</div>

<!-- loader -->

<!-- box details(ussd) -->
